import { GRAMMAR_ITEM_TYPES } from '@repo/config';
import { z } from 'zod';

const grammarCheckpointItemSchemaDefinition = z.object({
  id: z.number().int(),
  type: z.enum(GRAMMAR_ITEM_TYPES),
  prompt: z.string(),
  question: z.string().optional(),
  sentence: z.string().optional(),
  tokens: z.array(z.string()).optional(),
  options: z.array(z.string()).optional(),
});

export const grammarCheckpointItemSchema: typeof grammarCheckpointItemSchemaDefinition =
  grammarCheckpointItemSchemaDefinition;

export type IGrammarCheckpointItem = z.infer<typeof grammarCheckpointItemSchema>;
